var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-rule"},[_c('div',{staticClass:"rule-tit"},[_vm._v(" 排号说明 ")]),_c('div',{staticClass:"ruel_content"},[_vm._v(" "+_vm._s(_vm.ruledata.introduction)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }